@use '../../scss/utility/functions' as utility;
@use 'badge-vars';

:host {
  @include badge-vars.wb-badge-vars;

  --size: var(--badge-size);
  --icon-size: calc(var(--size) * 0.75);

  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
}

:host(:not([variant])) {
  @include badge-vars.wb-badge-custom-vars;
}

:host(:not([variant='warning'])) {
  background-color: var(--badge-background-color);
  color: var(--badge-icon-color);
  border-radius: var(--badge-border-radius);
}

:host([variant='success']) {
  @include badge-vars.wb-badge-success-vars;
}

:host([variant='warning']) {
  @include badge-vars.wb-badge-warning-vars;

  // patch for Safari browser
  svg {
    width: 100%;
  }
}

:host([variant='error']) {
  @include badge-vars.wb-badge-error-vars;
}

.wb-icon,
::slotted(.wb-icon) {
  --size: var(--icon-size); // overwrite inner --size of wb-icon
}

.triangle {
  fill: var(--badge-background-color);
}

.triangle-border {
  fill: var(--badge-border-ring-color);
}

:host([has-border]:not([variant='warning'])) {
  outline: var(--badge-border-ring-weight) solid var(--badge-border-ring-color);
}
